import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {Item, Level} from './sidenav.types'

@Component({
  selector: 'cft-holy-grail-grid-sidenav',
  templateUrl: './holy-grail-grid-sidenav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HolyGrailGridSidenavComponent {
  @Input() levels: Level[] = []
  @Input() level: string | undefined
  @Input() items: Item[] = []
}
